module.exports = __webpack_public_path__ + "img/logo-billo.7da3da66.svg";